import router from './router';
import store from './store';
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/getPageTitle';
import config from "@/config";
import { saveWrongPath } from './api/error';


const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // set page title
  document.title = getPageTitle(to.meta.title + " :: "+config.title)
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {

    // if user wants to go to login page, firstly we check if he has a valid token by dispatch event 'getInfo'.. if he has - we redirect him to the first route he has access
    if (to.path === '/login') {
      if(router.options.routes.length === 1){
        const { access } = await store.dispatch('user/getInfo')
        //const access = 0;
        // generate accessible routes map based on roles
        const accessRoutes = await store.dispatch('permission/generateRoutes', access)
        
        // dynamically add accessible routes
        router.addRoutes(accessRoutes);
      }
      // if is logged in, redirect to the home page
      next({ path: getFirstAvailablePath(router) })
      //vue.$loading(false);
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      
      const hasActions = store.getters.actions === 0 || store.getters.actions === 1;
      
      if (hasActions) {
        store.dispatch('permission/addLastRoute', from);

        next();
      } else {
        try {
          // get user info
          // note: actions must be an array such as: ['Admin', 'Clients', 'ATM'] etc..
          const { access } = await store.dispatch('user/getInfo')
          //const access = 0;
          
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', access)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          
          let goTo;
          
          // check if user has access to the requested route by its actions... if not - catch first available route and redirect user there
          // it is possible to get an error in 'router.resolve' so that's the reason of catch block
          try {

            let isRouteExists = router.resolve({path: to.path});
            if(isRouteExists.resolved.matched.length === 0 || isRouteExists.resolved.matched[0].path === '*'){
              for(let route of router.options.routes){
                if(route.path !== '/' && route.path !== '/authentication' && route.path != '/*' && route.path != '*'){
                  goTo = route;
                  break;
                }
              }
              if(to.path !== '/'){
                saveWrongPath(to.path);
              }
              next({path: goTo.path});
              return;
            }
          } catch(e) {
            // we are here because of router.resolve :)
            for(let route of router.options.routes){
              if(route.path !== '/' && route.path !== '/authentication' && route.path != '/*' && route.path != '*'){
                goTo = route;
                break;
              }
            }
            if(to.path !== '/'){
              saveWrongPath(to.path);
            }
            next({path: goTo.path});
            return;
          }

          // user has access to the route.. so redirect it
          next({ ...to, replace: true })
        } catch (error) {
          //console.log(error);
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    // has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      next(`/login?redirect=${to.path}`);
    }
  }
})


function getFirstAvailablePath(router){
  let path;
  for(let route of router.options.routes){
    if(route.path !== '/' && route.path !== '/authentication' && route.path != '/*' && route.path != '*'){
      path = route.path;
      break;
    }
  }
  return path;
}